<template>
    <v-container ma-0 pa-0>
        <v-row>
            <v-col cols="6" class="smallerHeight">
                <v-menu
                    v-model="datePickerShown"
                    :close-on-content-click="false"
                    :nudge-right="100"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    :disabled="disabled == 'true'"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            :value="dateString"
                            :label="dateLabel"
                            prepend-icon="mdi-calendar"
                            readonly
                            :disabled="disabled == 'true'"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="dateString" @input="datePickerShown = false" @change="onChange_DatePicker"></v-date-picker>
                </v-menu>
            </v-col>

            <v-col cols="6" class="smallerHeight">
                <v-menu
                    :close-on-content-click="false"
                    :nudge-right="80"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    :disabled="disabledTime == 'true'"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="timeString"
                            :value="timeString"
                            :label="timeLabel"
                            prepend-icon="mdi-clock"
                            :disabled="disabledTime == 'true'"
                            v-on="on"
                            type="time"
                        ></v-text-field>
                    </template>
                </v-menu>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex';

    import format from 'date-fns/format';
    import { eventBus } from '../../../../../main';


    export default {
        name: 'datetime',

        /* >>> *************************************************************** / /* Props */
        props: {

            value           : [ Date, null ],
            label           : String,
            disabled        : String,
            disabledTime    : String,
            briefcaller     : String,

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: DateTime.vue 'dblclick changes' only for 'CiCo' TImes!
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/DateTime.vue >>> mounted');
            eventBus.$on('dragendcicolist', this.onDragend_InSelectedCiCoList);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/DateTime.vue >>> mounted');
            this.setDateStrings();

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: DateTime.vue 'dblclick changes' only for 'CiCo' TImes!
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/DateTime.vue >>> mounted');
            eventBus.$off('dragendcicolist', this.onDragend_InSelectedCiCoList);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> --------------------------
                datePickerShown: false,
                dateString: null,
                dateLabel: this.label + ' date',
                timeString: null,
                timeLabel: this.label + ' time'
            }

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            value() {

                this.setDateStrings();

            }, // eo value()

            dateString(value) {

                let d = new Date(this.value);


                this.setDate(d, value);
                this.$emit('input', d);

            }, // eo dateString()

            timeString(value) {

                if (value !== '') {
                    let d = new Date(this.value);


                    this.setTime(d, value);
                    this.$emit('input', d);
                }

            } // eo timeString()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                // >>> --------------------------
                'actn_set_changedDateInSavedPayload',
            ]),


            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * setDateStrings()
            *
            * Desc:
            * Note:
            *
            */
            setDateStrings: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/DateTime.vue >>> setDateStrings');
                me.dateString = format(this.value, 'yyyy-MM-dd');
                me.timeString = format(this.value, 'HH:mm');

            }, // eo function setDateStrings()


            /*******************************************************************
            * setDate()
            *
            * Desc:
            * Note:
            *
            */
            setDate: function(date, parts) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/DateTime.vue >>> setDate');
                if ('string' === typeof parts) {
                    parts = parts.split('-');
                }
                date.setFullYear(parts[0]);
                date.setMonth(parts[1] - 1);
                date.setDate(parts[2]);

            }, // eo function setDate()


            /*******************************************************************
            * setTime()
            *
            * Desc:
            * Note:
            *
            */
            setTime: function(date, parts) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/DateTime.vue >>> setTime');
                if ('string' === typeof parts) {
                    parts = parts.split(':');
                }
                date.setHours(parts[0]);
                date.setMinutes(parts[1]);

            }, // eo function setTime()




            /******************************************************************* 'Listeners - '
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc:
            * Note:
            * Note:
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/DateTime.vue >>> onChange_DatePicker');
                if (this.briefcaller === undefined) {
                    eventBus.$emit('onchangedatepicker', value); // Datepicker in EventEditors(s)
                }

                if (this.briefcaller !== undefined) {
                    eventBus.$emit('onchangedatepickerbriefcall', { date: value, caller: this.briefcaller }); // Datepicker in 'CrewDetails: Brief'
                    this.actn_set_changedDateInSavedPayload({ date: value});
                }

            }, // eo function onChange_DatePicker()



            /******************************************************************* 'Listeners - Eventbus'
            * Listeners:EventBus:
            *******************************************************************/
            /******************************************************************* 'CiCo - Drop'
            * onDragend_InSelectedCiCoList()
            *
            * Desc:
            * Note:
            * Note: DateTime.vue 'dblclick changes' only for 'CiCo' TImes!
            *
            */
            onDragend_InSelectedCiCoList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/DateTime.vue >>> onDragend_InSelectedCiCoList');
                if (me.label === 'Checkin:') {
                    me.timeString = params.cicoItem.CIDate;
                }
                if (me.label === 'Checkout:') {
                    me.timeString = params.cicoItem.CODate;
                }

            }, // eo function onDragend_InSelectedCiCoList()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    /* diabled datepicker */
    .theme--light.v-input--is-disabled, .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
        color: #a1a7ad !important;
    }
</style>

<style scoped>
    .smallerHeight {
        padding-top: 2px;
        padding-bottom: 2px;
    }
</style>